import React from "react";
import { Link } from "react-router-dom";

const SafetyGuide = () => {
  return (
    <div className="content">
      <h2>
        <Link to="/">Home</Link> / Safety Guidelines
      </h2>
      <br />

      <p align="center">
        <b>ShareMy Safety Guidelines</b>
      </p>

      <p>
        <b>1. Introduction</b>
      </p>
      <p>Your safety is important.</p>
      <p>
        These Safety Guidelines provide recommendations to help you make
        informed decisions when interacting with other users and participating
        in activities through ShareMy.
      </p>
      <p>These Guidelines are informational only.</p>
      <p>
        They do not create legal obligations, guarantees, warranties, or duties
        of care.
      </p>

      <p>
        <b>2. Personal Responsibility</b>
      </p>
      <p>You are solely responsible for:</p>
      <ul>
        <li>Your decisions.</li>
        <li>Your safety.</li>
        <li>Your interactions.</li>
        <li>Your participation in activities.</li>
      </ul>
      <p>Always exercise your own judgment.</p>

      <p>
        <b>3. No Guarantee of Safety</b>
      </p>
      <p>ShareMy does not:</p>
      <ul>
        <li>Verify every user's identity.</li>
        <li>Perform background checks on every user.</li>
        <li>Supervise activities.</li>
        <li>Guarantee safety.</li>
        <li>Guarantee qualifications.</li>
        <li>Guarantee accuracy of user information.</li>
        <li>Guarantee conduct.</li>
      </ul>
      <p>Use the Services at your own risk.</p>

      <p>
        <b>4. Meeting Other Users</b>
      </p>
      <p>Before meeting someone:</p>
      <ul>
        <li>Meet in public.</li>
        <li>Tell someone where you're going.</li>
        <li>Arrange your own transportation.</li>
        <li>Trust your instincts.</li>
        <li>Leave immediately if you feel unsafe.</li>
      </ul>

      <p>
        <b>5. Participating in Activities</b>
      </p>
      <p>Before joining an activity:</p>
      <ul>
        <li>Evaluate your abilities.</li>
        <li>Understand the risks.</li>
        <li>Bring appropriate equipment.</li>
        <li>Follow applicable laws.</li>
        <li>Be prepared for changing conditions.</li>
      </ul>
      <p>Never participate beyond your skill level.</p>

      <p>
        <b>6. Financial Safety</b>
      </p>
      <p>Never:</p>
      <ul>
        <li>Send money to strangers.</li>
        <li>Share banking information unnecessarily.</li>
        <li>Respond to suspicious payment requests.</li>
        <li>Assume an activity has been verified by ShareMy.</li>
      </ul>

      <p>
        <b>7. Digital Safety</b>
      </p>
      <p>Protect your privacy.</p>
      <p>Avoid sharing:</p>
      <ul>
        <li>Social Security numbers.</li>
        <li>Financial information.</li>
        <li>Passwords.</li>
        <li>Government-issued identification.</li>
        <li>Other sensitive personal information.</li>
      </ul>

      <p>
        <b>8. Outdoor Activities</b>
      </p>
      <p>Many ShareMy activities occur outdoors.</p>
      <p>Outdoor environments involve risks such as:</p>
      <ul>
        <li>Weather.</li>
        <li>Wildlife.</li>
        <li>Water.</li>
        <li>Terrain.</li>
        <li>Traffic.</li>
        <li>Remote locations.</li>
      </ul>
      <p>Prepare appropriately.</p>

      <p>
        <b>9. Emergency Situations</b>
      </p>
      <p>If you are in immediate danger:</p>
      <p>Contact local emergency services immediately.</p>
      <p>Do not rely on ShareMy to provide emergency assistance.</p>

      <p>
        <b>10. Reporting Safety Concerns</b>
      </p>
      <p>
        If you believe another user has violated the Terms of Use, Community
        Guidelines, or applicable law, you are encouraged to report the matter
        through the Services.
      </p>
      <p>
        ShareMy may review reports but cannot guarantee investigation or
        enforcement.
      </p>

      <p>
        <b>11. Official ShareMy Events</b>
      </p>
      <p>
        From time to time, ShareMy may identify certain activities as Official
        ShareMy Events.
      </p>
      <p>
        Unless ShareMy expressly identifies an activity as an Official ShareMy
        Event, activities should be considered user-organized activities.
      </p>
      <p>
        Even at Official ShareMy Events, users remain responsible for exercising
        reasonable judgment and complying with these Safety Guidelines unless
        additional written instructions are provided by ShareMy.
      </p>

      <p>
        <b>12. Relationship to the Terms</b>
      </p>
      <p>
        These Safety Guidelines supplement the{" "}
        <Link to="/terms-of-use">Terms of Use</Link>.
      </p>
      <p>
        Nothing in these Guidelines creates a contractual, fiduciary, special,
        or other legal duty on the part of ShareMy.
      </p>
      <p>
        If there is any conflict between these Guidelines and the Terms of Use,
        the Terms of Use control.
      </p>
    </div>
  );
};

export default SafetyGuide;
